module.exports = __webpack_public_path__ + "fonts/Poppins-Light.5f64faba.eot";